import { Swiper, SwiperSlide } from 'swiper/react';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoDialogVideo from 'eco-design/elements/eco-dialog-video';
import { Scrollbar, Navigation } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function L() {
    const { useLang, useState } = useGlobal();
    const { t } = useLang('powerbackup');
    const [source, setSource] = useState('');

    const play = 'https://websiteoss.ecoflow.com/upload/image/1747290954709/play.png';
    const cards: any = [
        {
            title: t('secL_list1_title'),
            desc: t('secL_list1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747290953341/1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1747290953175/1-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747290953175/1-h5.jpg',
            video: 'https://www.youtube.com/embed/JcKq6neGxXk',
        },
        {
            title: t('secL_list2_title'),
            desc: t('secL_list2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747290954500/2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1747290953525/2-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747290953525/2-h5.jpg',
            video: 'https://www.youtube.com/embed/3aTQSXtpHmU',
        },
        {
            title: t('secL_list3_title'),
            desc: t('secL_list3_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747290954123/3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1747290954301/3-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747290954301/3-h5.jpg',
            video: 'https://www.youtube.com/embed/WE9Ct6Pz8nw',
        },
        {
            title: t('secL_list4_title'),
            desc: t('secL_list4_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747290953719/4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1747290953897/4-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747290953897/4-h5.jpg',
            video: 'https://www.youtube.com/embed/hMVkwZ5ZUCI',
        },
    ];

    return (
        <div id="power-backup-L" className={`power-backup-L ${css['power-backup-L']}`}>
            <EcoSpace />
            <div className="text-box">
                <p className="title">{t('secL_title')}</p>
            </div>

            <Swiper
                className="swiper-container"
                slidesPerView={'auto'}
                modules={[Scrollbar, Navigation]}
                navigation={true}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 25,
                    snapOnRelease: true,
                }}
            >
                {cards.map((i, idx) => (
                    <SwiperSlide className="swiper-slide" key={idx}>
                        <div className="img-box" onClick={() => setSource(i.video)}>
                            <EcoImg className="bg" pc={i.pc} pad={i.pad} h5={i.h5} />
                            <EcoImg className="play" pc={play} />
                        </div>
                        <div className="info-box">
                            <div className="title">{i.title}</div>
                            <div className="desc">{i.desc}</div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {/* 避免 dialog标签在低版本浏览器中不识别直接出现 */}
            {!!source && <EcoDialogVideo open={!!source} src={source} callback={() => setSource('')} />}
        </div>
    );
}
